import { Component } from '@verndale/core';
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
import 'swiper/css/bundle';

class RelatedOfficesAndNewsSlider extends Component {
  swiperInstance: Swiper | undefined = undefined;

  setupDefaults() {
    this.dom = {
      $swiperContainer: this.el.querySelector<HTMLElement>('.swiper-container'),
      $swiperNext: this.el.querySelector<HTMLElement>('.swiper-button-next'),
      $swiperPrevious: this.el.querySelector<HTMLElement>('.swiper-button-prev'),
      $swiperScroll: this.el.querySelector<HTMLElement>('.swiper-scrollbar'),
      $controls: this.el.querySelector<HTMLElement>('.related-blogs-and-news-slider__controls'),
      $cards: this.el.querySelectorAll<HTMLElement>('.generic-image-card')
    };

    this.initSlider();

    if (this.dom.$controls && (this.dom.$cards as NodeList).length <= 2) {
      (this.dom.$controls as HTMLElement).style.display = 'none';
    }
  }

  initSlider() {
    if (this.dom.$swiperContainer) {
      this.swiperInstance = new Swiper(this.dom.$swiperContainer as HTMLElement, {
        modules: [Navigation, Pagination],
        slidesPerView: 1,
        spaceBetween: 40,
        keyboard: {
          enabled: false
        },
        breakpoints: {
          767: {
            slidesPerView: 2,
            spaceBetween: 40
          },
          1024: {
            slidesPerView: 3,
            spaceBetween: 40
          }
        },
        // Navigation arrows
        navigation: {
          nextEl: this.dom.$swiperNext as HTMLElement,
          prevEl: this.dom.$swiperPrevious as HTMLElement
        },
        pagination: {
          el: this.dom.$swiperScroll as HTMLElement,
          type: 'progressbar'
        }
      });
    }
  }
}

export default RelatedOfficesAndNewsSlider;
